document.addEventListener("DOMContentLoaded", function () {
if (window.ATTACH_MODULE_INITIALIZED) return;
window.ATTACH_MODULE_INITIALIZED = true;
  let hasExplicitlyAddedToCart = false;

  // TRACK PDP VARIANT ID CHANGES
  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput) {
    window.PDP_SELECTED_VARIANT_ID = variantInput.value;
    console.log("Initial PDP_SELECTED_VARIANT_ID:", variantInput.value);
  }

  document.addEventListener("on:variant:change", function (event) {
    if (event.detail?.variant?.id) {
      window.PDP_SELECTED_VARIANT_ID = event.detail.variant.id;
      console.log("Updated PDP_SELECTED_VARIANT_ID:", event.detail.variant.id);
    }
  });
  const modal = document.getElementById("at-productModal");

  // ARROW SCROLL
  document.querySelectorAll(".carousel-arrow").forEach(button => {
    button.addEventListener("click", function (event) {
      event.stopPropagation();
      event.preventDefault();
      const direction = button.dataset.direction;
      const track = button.closest(".carousel-wrapper").querySelector(".carousel-track");
      const scrollAmount = 300;
      track.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
    });
  });

  // ARROW VISIBILITY
  function updateArrowVisibility(wrapper) {
    const track = wrapper.querySelector(".carousel-track");
    const leftArrow = wrapper.querySelector(".left-arrow");
    const rightArrow = wrapper.querySelector(".right-arrow");
    if (!track || !leftArrow || !rightArrow) return;
    const scrollLeft = track.scrollLeft;
    const maxScrollLeft = track.scrollWidth - track.clientWidth;
    leftArrow.style.display = scrollLeft > 0 ? 'flex' : 'none';
    rightArrow.style.display = scrollLeft < maxScrollLeft - 1 ? 'flex' : 'none';
  }

  // INIT ARROWS
  document.querySelectorAll(".carousel-wrapper").forEach(wrapper => {
    const track = wrapper.querySelector(".carousel-track");
    updateArrowVisibility(wrapper);
    track.addEventListener("scroll", () => updateArrowVisibility(wrapper));
    new ResizeObserver(() => updateArrowVisibility(wrapper)).observe(track);
  });

  // PILL ACTIVATION ON SCROLL
  document.querySelectorAll(".carousel-track").forEach((track) => {
    track.addEventListener("scroll", function () {
      const wrapper = track.closest(".carousel-wrapper");
      const pillsContainer = wrapper?.querySelector(".carousel-pills");
      if (!pillsContainer) return;
      const pills = pillsContainer.querySelectorAll(".carousel-pill");
      const children = Array.from(track.children).filter(el => el.classList.contains("at-modal-product-kit-wrapper"));
      if (children.length === 0) return;
      const scrollLeft = track.scrollLeft;
      const childWidth = children[0].offsetWidth + parseInt(getComputedStyle(children[0]).marginRight || 0);
      const index = Math.round(scrollLeft / childWidth);
      pills.forEach(p => p.classList.remove("active"));
      if (pills[index]) pills[index].classList.add("active");
    });
  });

  // INIT FIRST PILL ACTIVE
  document.querySelectorAll(".carousel-wrapper").forEach(wrapper => {
    const pillsContainer = wrapper.querySelector(".carousel-pills");
    if (!pillsContainer) return;
    const pills = pillsContainer.querySelectorAll(".carousel-pill");
    pills.forEach(p => p.classList.remove("active"));
    if (pills[0]) pills[0].classList.add("active");
  });

  // OPEN MODAL
  const openBtn = document.querySelector(".select-items-btn");
  const closeBtn = document.querySelector(".close-btn");

  // Track if modal was opened and closed without interaction
  let modalOpenedWithoutAction = false;

  if (openBtn && modal) {
    openBtn.addEventListener("click", function () {
      // ✅ Fetch latest PDP values on modal open
      const qtyInput = document.querySelector('input[name="quantity"]');
      const variantId = document.querySelector('input[name="id"]')?.value;
      const price = parseInt(document.querySelector('.at-modal-product-wrapper [data-product-price]')?.dataset.productPrice || "0", 10);
      const selectedQty = parseInt(qtyInput?.value || "1", 10);

      window.PDP_SELECTED_VARIANT_ID = variantId;
      window.PDP_SELECTED_VARIANT_PRICE = price;
      window.PDP_SELECTED_QTY = selectedQty;

      modal.dataset.variantId = variantId;
      modal.dataset.variantPrice = price;
      modal.dataset.selectedQty = selectedQty;

      modal.style.display = "block";
      document.body.style.overflow = "hidden";

      modalOpenedWithoutAction = true; // Track modal open

      // ✅ Trigger updateStickyBar now that modal DOM is rendered
      setTimeout(updateStickyBar, 10);
    });
  }

  // Helper to add main product to cart
  async function addMainProductToCartIfNeeded() {
    if (
      modalOpenedWithoutAction &&
      !hasExplicitlyAddedToCart &&
      window.PDP_SELECTED_VARIANT_ID
    ) {
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [
              {
                id: window.PDP_SELECTED_VARIANT_ID,
                quantity: window.PDP_SELECTED_QTY || 1,
              },
            ],
          }),
        });
        // Optional notification toast
        const notificationTemplate = document.getElementById("AddedNotification");
        if (notificationTemplate) {
          const toastEl = notificationTemplate.content.cloneNode(true);
          const notification = toastEl.querySelector("added-notification");
          notification.dataset.productTitle =
            window.customProductData?.product?.title || "Product";
          document.body.appendChild(notification);
        }
      } catch (e) {
        // Optionally handle error
      }
    }
    // Reset for next modal open
    modalOpenedWithoutAction = false;
    hasExplicitlyAddedToCart = false;
  }

  if (closeBtn && modal) {
    closeBtn.addEventListener("click", function () {
      addMainProductToCartIfNeeded();
      handleModalCloseFallback();
    });
    window.addEventListener("click", function (e) {
      if (e.target === modal) {
        addMainProductToCartIfNeeded();
        handleModalCloseFallback();
      }
    });
  }

  // HIDE VARIANT ERROR ON CHANGE
  document.querySelectorAll('.at-variant-selector input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', function () {
      const wrapper = radio.closest('.at-variant-selector-wrapper');
      const error = wrapper.querySelector('.variant-error-message');
      if (error) error.style.display = 'none';
    });
  });

  // PRICE FORMATTER
  function formatMoney(paisa) {
    return '₹' + (paisa / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  // UPDATE STICKY PRICE & BUTTON
function updateStickyBar() {
  const totalPriceEl = document.getElementById('sticky-total-price');
  const btn = document.getElementById('add-selected-to-cart');

  // ✅ Failsafe guard
  if (!totalPriceEl || !btn) {
    console.warn("Sticky footer element(s) not found – skipping updateStickyBar.");
    return;
  }

  const checkboxes = document.querySelectorAll('.kit-product-checkbox:checked');
  const basePrice = parseInt(modal?.dataset.variantPrice || window.PDP_SELECTED_VARIANT_PRICE || 0, 10);
  let total = basePrice;

  checkboxes.forEach(cb => {
    const price = parseInt(cb.getAttribute('data-product-price'), 10) || 0;
    total += price;
  });

  totalPriceEl.innerHTML = 'Total Price: <span style="color:#00A207">' + formatMoney(total) + '</span>';
  btn.disabled = false;
}




  document.querySelectorAll('.kit-product-checkbox').forEach(cb => {
    cb.addEventListener('change', updateStickyBar);
  });


  // HIDE EMPTY VARIANT SELECTORS
  const variantSelectorWrappers = document.querySelectorAll('.at-variant-selector-wrapper');

  variantSelectorWrappers.forEach(wrapper => {
    const labels = wrapper.querySelectorAll('label.opt-label');
    const nonEmptyLabels = Array.from(labels).filter(label => label.textContent.trim() !== "");

    // ✅ Hide wrapper if zero or only one valid label
    if (nonEmptyLabels.length <= 1) {
      wrapper.classList.add("hidden");
    }
  });

  // PRESELECT FIRST CHECKBOX AND FIRST VARIANT ONLY IF SINGLE OPTION
  const tracks = document.querySelectorAll('[id^="carousel-track-"]');
  tracks.forEach(track => {
    const wrappers = track.querySelectorAll('.at-modal-product-kit-wrapper');
    wrappers.forEach((wrapper, idx) => {
      const checkbox = wrapper.querySelector('.kit-product-checkbox');
      const radios = wrapper.querySelectorAll('input[type="radio"]');
      if (!checkbox) return;
      if (idx === 0) {
        checkbox.checked = true;
        checkbox.dispatchEvent(new Event('change'));
      }
      if (radios.length === 1 && checkbox.checked) {
        radios[0].checked = true;
      }
    });
  });

  // ADD TO CART
const addSelectedBtn = document.getElementById("add-selected-to-cart");
if (addSelectedBtn) {
  addSelectedBtn.addEventListener("click", async function () {  const items = [];
  const checkboxes = document.querySelectorAll(".kit-product-checkbox:checked");
  let missingVariant = false;
  let firstMissingElement = null;

  const modal = document.getElementById("at-productModal");

  // Always try to push the PDP main variant first
  if (window.PDP_SELECTED_VARIANT_ID) {
    const qty = window.PDP_SELECTED_QTY || 1;
    items.push({ id: window.PDP_SELECTED_VARIANT_ID, quantity: qty });
  }

  // Loop through checked kit items and validate variant selection
  checkboxes.forEach((checkbox) => {
    const wrapper = checkbox.closest(".at-modal-product-kit-wrapper");
    const variantWrapper = wrapper.querySelector(".at-variant-selector-wrapper");
    const selectedRadio = variantWrapper?.querySelector('input[type="radio"]:checked');
    const errorMessage = variantWrapper?.querySelector('.variant-error-message');

    if (selectedRadio && selectedRadio.value) {
      items.push({ id: selectedRadio.value, quantity: 1 });
      if (errorMessage) errorMessage.style.display = "none";
    } else {
      if (errorMessage) errorMessage.style.display = "block";
      if (!missingVariant) {
        missingVariant = true;
        firstMissingElement = wrapper;
      }
    }
  });

  // Scroll to the first item with missing variant
  if (missingVariant && firstMissingElement) {
    firstMissingElement.scrollIntoView({ behavior: "smooth", block: "center" });
    return;
  }

  try {
    // ✅ If only main product is selected, mimic "Skip to Cart" behavior
    if (checkboxes.length === 0) {
      const variantId = window.PDP_SELECTED_VARIANT_ID;
      const selectedQty = window.PDP_SELECTED_QTY || 1;

      if (!variantId) return;

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: selectedQty }] }),
      });

      if (response.ok) {
if (modal) modal.style.display = "none";
        document.body.style.overflow = "";

        const notificationTemplate = document.getElementById("AddedNotification");
        if (notificationTemplate) {
          const toastEl = notificationTemplate.content.cloneNode(true);
          const notification = toastEl.querySelector("added-notification");
          notification.dataset.productTitle = window.customProductData?.product?.title || "Product";
          document.body.appendChild(notification);
        }
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.description}`);
      }

      return; // stop execution
    }

    // ✅ Normal bundle flow: main product + checked items with valid variants
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    });

    if (response.ok) {
      hasExplicitlyAddedToCart = true;
      setTimeout(() => {
        modal.style.display = "none";
        document.body.style.overflow = "";
      }, 50);

      if (window.csToast) {
        window.csToast.showToast('success', 'Items added to cart');
      }

      const notificationTemplate = document.getElementById("AddedNotification");
      if (notificationTemplate) {
        const toastEl = notificationTemplate.content.cloneNode(true);
        const notification = toastEl.querySelector("added-notification");
        notification.dataset.productTitle = window.customProductData?.product?.title || "Product";
        document.body.appendChild(notification);
      }
    } else {
      const errorData = await response.json();
      alert(`Error: ${errorData.description}`);
    }
  } catch (error) {
    console.error("Error adding to cart:", error);
    alert("Something went wrong while adding to cart.");
  }
});
}

  // SKIP TO CART
  const skipBtn = document.getElementById("skip-to-cart-btn");
  if (skipBtn) {
    skipBtn.addEventListener("click", async function () {
      const variantId = window.PDP_SELECTED_VARIANT_ID;
      const qtyInput = document.querySelector('input[name="quantity"]');
      const selectedQty = parseInt(qtyInput?.value || "1", 10);

      if (!variantId) return;

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: variantId, quantity: selectedQty }] }),
        });
        if (response.ok) {
          hasExplicitlyAddedToCart = true;
          setTimeout(() => {
            modal.style.display = "none";
            document.body.style.overflow = "";
          }, 50);
        } else {
          const errorData = await response.json();
          alert(`Error: ${errorData.description}`);
        }
      } catch (error) {
        alert("Error adding to cart.");
      }

      const notificationTemplate = document.getElementById("AddedNotification");
      if (notificationTemplate) {
        const toastEl = notificationTemplate.content.cloneNode(true);
        const notification = toastEl.querySelector("added-notification");
        notification.dataset.productTitle = window.customProductData?.product?.title || "Product";
        document.body.appendChild(notification);
      }
    });
  }

  function handleModalCloseFallback() {
  modal.style.display = "none";
  document.body.style.overflow = "";

  if (!hasExplicitlyAddedToCart && window.PDP_SELECTED_VARIANT_ID) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: window.PDP_SELECTED_VARIANT_ID, quantity: window.PDP_SELECTED_QTY || 1 }]
      })
    })
    .then(res => {
      if (!res.ok) {
        return res.json().then(err => Promise.reject(err));
      }

      // Optional notification toast
      const notificationTemplate = document.getElementById("AddedNotification");
      if (notificationTemplate) {
        const toastEl = notificationTemplate.content.cloneNode(true);
        const notification = toastEl.querySelector("added-notification");
        notification.dataset.productTitle = window.customProductData?.product?.title || "Product";
        document.body.appendChild(notification);
      }
      // Reset flag for next time
      hasExplicitlyAddedToCart = false;
    })
    .catch(() => {
      alert("Something went wrong while adding main product to cart.");
      // Reset flag for next time
      hasExplicitlyAddedToCart = false;
    });
  }

  // Reset flag for next time is now handled after fetch completes
}

});
